import featureFlagsConstants from '../Constants/featureFlags.constants';

const initialState = {
	CAN_ORDER_IN_PACKS: false,
	CAN_SUB_PACKAGE_ORDER: false,
};

function featureFlags(state = initialState, action) {
	switch (action.type) {
		case featureFlagsConstants.SET_FEATURE_FLAGS:
			return {
				...state,
				...action.payload,
			};
		case featureFlagsConstants.UPDATE_FEATURE_FLAG:
			return {
				...state,
				[action.payload.flag]: action.payload.value,
			};
		default:
			return state;
	}
}

export default featureFlags;
